import React from 'react';
import styled from 'styled-components';
import { colors } from '@styles/theme-chakra';

const SocialLink = styled.a`
  text-decoration: none;
`;

const SocialButton = styled.button`
  background: #000;
  border: none;
  cursor: pointer;
  border-radius: 9999px;
  font-size: 1rem;
  transition: 25ms ease-out;
  padding: 0.5rem;

  &.email {
    &:active,
    &:hover {
      background-color: #5e5e5e;
      border-color: #5e5e5e;
    }
  }

  &.facebook {
    &:active,
    &:hover {
      background-color: #2d4373;
      border-color: #2d4373;
    }
  }

  &.instagram {
    &:active,
    &:hover {
      background-color: #dd3856;
      border-color: #dd3856;
    }
  }

  &.linkedin {
    &:active,
    &:hover {
      background-color: #046293;
      border-color: #046293;
    }
  }

  &.twitter {
    &:active,
    &:hover {
      background-color: #2795e9;
      border-color: #2795e9;
    }
  }

  &.pinterest {
    &:active,
    &:hover {
      background-color: #2795e9;
      border-color: #2795e9;
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5em;
  width: 1.5em;

  svg {
    width: 1.25em;
    height: 1.25em;
    fill: #fff;
    stroke: none;
  }
`;

const PROFILES = {
  facebook: 'https://www.facebook.com/askzeta',
  instagram: 'https://www.instagram.com/askzeta/',
  linkedIn: 'https://www.linkedin.com/company/askzeta',
  twitter: 'https://twitter.com/askzeta',
  pinterest: 'https://pinterest.com/askzeta',
  youtube: 'https://www.youtube.com/channel/UC4ATyZg_5sMfFtGCiZqCwxw',
  reddit: 'https://www.reddit.com/r/ZetaJointCards/',
  tiktok: 'https://www.tiktok.com/@askzeta'
};

export function Reddit({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.reddit} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM36.4912 20.4912C38.4281 20.4912 40 22.0631 40 24C40 25.4315 39.1298 26.6666 37.979 27.228C38.0351 27.5649 38.0632 27.9017 38.0632 28.2666C38.0632 33.6561 31.8035 38.007 24.0562 38.007C16.3088 38.007 10.0491 33.6561 10.0491 28.2666C10.0491 27.9017 10.0772 27.5368 10.1333 27.2C8.89826 26.6385 8.05615 25.4315 8.05615 24C8.05615 22.0631 9.62808 20.4912 11.5649 20.4912C12.4912 20.4912 13.3614 20.8842 13.979 21.4736C16.393 19.7052 19.7333 18.6105 23.4667 18.4982L25.2351 10.1333C25.2912 9.96486 25.3755 9.82451 25.5158 9.7403C25.6562 9.65609 25.8246 9.62802 25.993 9.65609L31.8035 10.8912C32.1965 10.0491 33.0386 9.48767 34.0211 9.48767C35.3965 9.48767 36.5193 10.6105 36.5193 11.9859C36.5193 13.3614 35.3965 14.4842 34.0211 14.4842C32.6737 14.4842 31.579 13.4175 31.5228 12.0982L26.3298 11.0035L24.7298 18.4982C28.379 18.6385 31.6912 19.7614 34.0772 21.4736C34.6948 20.8561 35.5369 20.4912 36.4912 20.4912ZM18.4983 24C17.1228 24 16 25.1228 16 26.4982C16 27.8736 17.1228 28.9964 18.4983 28.9964C19.8737 28.9964 20.9965 27.8736 20.9965 26.4982C20.9965 25.1228 19.8737 24 18.4983 24ZM24.0281 34.9193C24.9825 34.9193 28.2386 34.807 29.9509 33.0947C30.2035 32.8421 30.2035 32.4491 30.007 32.1684C29.7544 31.9157 29.3333 31.9157 29.0807 32.1684C27.986 33.235 25.7123 33.628 24.0562 33.628C22.4 33.628 20.0983 33.235 19.0316 32.1684C18.779 31.9157 18.3579 31.9157 18.1053 32.1684C17.8526 32.421 17.8526 32.8421 18.1053 33.0947C19.7895 34.7789 23.0737 34.9193 24.0281 34.9193ZM27.0035 26.4982C27.0035 27.8736 28.1263 28.9964 29.5018 28.9964C30.8772 28.9964 32 27.8736 32 26.4982C32 25.1228 30.8772 24 29.5018 24C28.1263 24 27.0035 25.1228 27.0035 26.4982Z"
            fill={dark ? colors.primary : colors.white}
          />
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function Facebook({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.facebook} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17_61)">
            <path
              d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9789 8.77641 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.8331 9.375 29.3152 9.375C31.9402 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6613C28.68 15.75 27.75 17.6002 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9789 48 24Z"
              fill={dark ? colors.primary : colors.white}
            />
          </g>
          <defs>
            <clipPath id="clip0_17_61">
              <rect width="48" height="48" fill={dark ? colors.primary : colors.white} />
            </clipPath>
          </defs>
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function Instagram({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.instagram} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17_63)">
            <path
              d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
              fill={dark ? colors.primary : colors.white}
            />
            <path
              d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
              fill={dark ? colors.primary : colors.white}
            />
            <path
              d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
              fill={dark ? colors.primary : colors.white}
            />
          </g>
          <defs>
            <clipPath id="clip0_17_63">
              <rect width="48" height="48" fill={dark ? colors.primary : colors.white} />
            </clipPath>
          </defs>
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function Twitter({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.twitter} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17_80)">
            <path
              d="M15.1003 43.5C33.2091 43.5 43.1166 28.4935 43.1166 15.4838C43.1166 15.0619 43.1072 14.6307 43.0884 14.2088C45.0158 12.815 46.679 11.0886 48 9.11066C46.205 9.90926 44.2993 10.4308 42.3478 10.6575C44.4026 9.42588 45.9411 7.491 46.6781 5.21159C44.7451 6.35718 42.6312 7.16528 40.4269 7.60128C38.9417 6.02318 36.978 4.97829 34.8394 4.62816C32.7008 4.27803 30.5064 4.64216 28.5955 5.66425C26.6846 6.68635 25.1636 8.30947 24.2677 10.2827C23.3718 12.2559 23.1509 14.4693 23.6391 16.5807C19.725 16.3842 15.8959 15.3675 12.4 13.5963C8.90405 11.825 5.81939 9.33893 3.34594 6.29909C2.0888 8.46655 1.70411 11.0314 2.27006 13.4722C2.83601 15.9131 4.31013 18.047 6.39281 19.44C4.82926 19.3904 3.29995 18.9694 1.93125 18.2119V18.3338C1.92985 20.6084 2.7162 22.8132 4.15662 24.5736C5.59704 26.334 7.60265 27.5412 9.8325 27.99C8.38411 28.3863 6.86396 28.4441 5.38969 28.1588C6.01891 30.1149 7.24315 31.8258 8.89154 33.0527C10.5399 34.2796 12.5302 34.9613 14.5847 35.0025C11.0968 37.7423 6.78835 39.2283 2.35313 39.2213C1.56657 39.2201 0.780798 39.1719 0 39.0769C4.50571 41.9676 9.74706 43.5028 15.1003 43.5Z"
              fill={dark ? colors.primary : colors.white}
            />
          </g>
          <defs>
            <clipPath id="clip0_17_80">
              <rect width="48" height="48" fill={dark ? colors.primary : colors.white} />
            </clipPath>
          </defs>
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function YouTube({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.youtube} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.5219 14.4001C47.5219 14.4001 47.0531 11.0907 45.6094 9.6376C43.7812 7.7251 41.7375 7.71572 40.8 7.60322C34.0875 7.11572 24.0094 7.11572 24.0094 7.11572H23.9906C23.9906 7.11572 13.9125 7.11572 7.2 7.60322C6.2625 7.71572 4.21875 7.7251 2.39062 9.6376C0.946875 11.0907 0.4875 14.4001 0.4875 14.4001C0.4875 14.4001 0 18.2907 0 22.172V25.8095C0 29.6907 0.478125 33.5813 0.478125 33.5813C0.478125 33.5813 0.946875 36.8907 2.38125 38.3438C4.20937 40.2563 6.60938 40.1907 7.67813 40.397C11.5219 40.7626 24 40.8751 24 40.8751C24 40.8751 34.0875 40.8563 40.8 40.3782C41.7375 40.2657 43.7812 40.2563 45.6094 38.3438C47.0531 36.8907 47.5219 33.5813 47.5219 33.5813C47.5219 33.5813 48 29.7001 48 25.8095V22.172C48 18.2907 47.5219 14.4001 47.5219 14.4001ZM19.0406 30.2251V16.7345L32.0062 23.5032L19.0406 30.2251Z"
            fill={dark ? colors.primary : colors.white}
          />
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function Pinterest({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.pinterest} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17_71)">
            <path
              d="M24 0C10.7438 0 0 10.7438 0 24C0 34.1719 6.32812 42.8531 15.2531 46.35C15.0469 44.4469 14.85 41.5406 15.3375 39.4688C15.7781 37.5938 18.15 27.5437 18.15 27.5437C18.15 27.5437 17.4281 26.1094 17.4281 23.9813C17.4281 20.6438 19.3594 18.15 21.7687 18.15C23.8125 18.15 24.8063 19.6875 24.8063 21.5344C24.8063 23.5969 23.4937 26.6719 22.8187 29.5219C22.2562 31.9125 24.0187 33.8625 26.3719 33.8625C30.6375 33.8625 33.9187 29.3625 33.9187 22.875C33.9187 17.1281 29.7937 13.1063 23.8969 13.1063C17.0719 13.1063 13.0594 18.225 13.0594 23.5219C13.0594 25.5844 13.8562 27.7969 14.85 28.9969C15.0469 29.2312 15.075 29.4469 15.0187 29.6813C14.8406 30.4406 14.4281 32.0719 14.3531 32.4C14.25 32.8406 14.0063 32.9344 13.5469 32.7188C10.5469 31.3219 8.67188 26.9438 8.67188 23.4188C8.67188 15.8438 14.175 8.89688 24.525 8.89688C32.85 8.89688 39.3187 14.8313 39.3187 22.7625C39.3187 31.0312 34.1063 37.6875 26.8688 37.6875C24.4406 37.6875 22.1531 36.4219 21.3656 34.9313C21.3656 34.9313 20.1656 39.5156 19.875 40.6406C19.3312 42.7219 17.8687 45.3375 16.8937 46.9313C19.1437 47.625 21.525 48 24 48C37.2562 48 48 37.2562 48 24C48 10.7438 37.2562 0 24 0Z"
              fill={dark ? colors.primary : colors.white}
            />
          </g>
          <defs>
            <clipPath id="clip0_17_71">
              <rect width="48" height="48" fill={dark ? colors.primary : colors.white} />
            </clipPath>
          </defs>
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

export function TikTok({ dark = false }) {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.tiktok} target="_blank">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z"
            fill={dark ? colors.primary : colors.white}
          />
        </svg>
      </SocialLink>
    </IconContainer>
  );
}
